export default __webpack_public_path__ + "static/media/Badge_Lock200x200.afcc6c91.png";